import React from "react";

const LoadingPage = () => {
  return (
    <div className="flex justify-center items-center min-h-screen justify-content-center align-items-center loading-page-row">
      <div className="w-[100px] flex gap-2 items-center justify-center">
        <div className="w-3 h-3 rounded-full bg-[var(--accent-primary)] animate-bounce [animation-delay:-0.3s]" />
        <div className="w-3 h-3 rounded-full bg-[var(--accent-primary)] animate-bounce [animation-delay:-0.15s]" />
        <div className="w-3 h-3 rounded-full bg-[var(--accent-primary)] animate-bounce" />
      </div>
    </div>
  );
};

export default LoadingPage;
